import { useMemo } from 'react';

import { useHomeWidgetPositionsQuery } from '../use-home-widget-positions-query';
import { useNewPositioningWidgetsFeature } from '../use-new-positioning-widgets-feature';
import type { TGetWidgetsQuerySpec, TWidgetId } from './types';
import { transformSpanToClassname } from './utils';

export const useWidgetsLayout = () => {
  const {
    isNewPositioningWidgetsEnabled,
    isLoading: loadingNewPositioningWidgetsFeature,
  } = useNewPositioningWidgetsFeature();
  const {
    data,
    loading: loadingWidgetsLayout,
    error,
    refetch,
  } = useHomeWidgetPositionsQuery({
    skip:
      !isNewPositioningWidgetsEnabled || loadingNewPositioningWidgetsFeature,
  });

  const widgetsConfigLayout = useMemo(() => {
    return data.map(widget => {
      const spanConfig: TGetWidgetsQuerySpec['span'] = {
        lg: widget.span_config.lg,
        md: widget.span_config.md,
        sm: widget.span_config.sm,
      };

      return {
        id: widget.identifier as TWidgetId,
        className: transformSpanToClassname(spanConfig),
        span: spanConfig,
      } satisfies TGetWidgetsQuerySpec;
    });
  }, [data]);

  const loading = loadingNewPositioningWidgetsFeature || loadingWidgetsLayout;

  return {
    isFeatureFlagEnabled: isNewPositioningWidgetsEnabled,
    widgetsConfigLayout,
    loading,
    error,
    refetch,
  };
};
